module.exports = __webpack_public_path__ + "img/top-techs.222909b9.png";